import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

function initTrainingFeaturedSpeakerSwipers() {
	const swipers = document.querySelectorAll('[data-js="tef-speakers-swiper"]');
	if (!swipers.length) return;

	swipers.forEach((el) => {
		if (el.swiper) return;

		const wrapper = el.closest('.media') || el.parentElement;
		const prevEl = wrapper?.querySelector('[data-js="tef-speakers-prev"]');
		const nextEl = wrapper?.querySelector('[data-js="tef-speakers-next"]');
		const paginationEl = wrapper?.querySelector('[data-js="tef-speakers-pagination"]');
		const totalSlides = Number(el.dataset.slides || 1);
		const hasManySlides = totalSlides > 1;

		new Swiper(el, {
			modules: [Navigation, Pagination],
			slidesPerView: 1,
			spaceBetween: 0,
			loop: hasManySlides,
			speed: 450,
			watchOverflow: true,
			allowTouchMove: hasManySlides,
			navigation: {
				prevEl: hasManySlides ? prevEl : null,
				nextEl: hasManySlides ? nextEl : null,
			},
			pagination: {
				el: hasManySlides ? paginationEl : null,
				clickable: true,
				bulletClass: 'tef-bullet',
				bulletActiveClass: 'is-active',
				renderBullet: (index, className) => `<span class="${className}" aria-label="Speaker ${index + 1}"></span>`,
			},
		});
	});
}

export default function trainingAndEventsFeaturedBlock() {
	initTrainingFeaturedSpeakerSwipers();
}
